import { acCustomerTypes } from '../acReduxExports';

const customersInitialState: AcCustomerState = {
	customers: null,
	loader: false,
	customerCount: 0,
	historyRecords: null,
	historyRecordsCount: 0,
	chargers: null,
	chargerCount: 0,
	selectedCharger: null,
	customerChargerListTableProps: {
		view: 'list',
		pageSize: 15,
		pageNumber: 1,
		order: 'ascending',
		sortBy: 'alarmStatus',
		searchTerm: '',
	},
	customerListTableProps: {
		view: 'list',
		sortBy: 'name',
		order: 'ascending',
		pageSize: 15,
		pageNumber: 1,
		searchTerm: '',
	},
	historyRecordTableProps: {
		view: 'list',
		sortBy: '',
		order: 'ascending',
		pageSize: 15,
		pageNumber: 1,
		searchTerm: '',
	},
	individualCustomerDetail: null,
	individualCustomerDetailLoader: false,
};

const accustomersReducer = (
	state: AcCustomerState = customersInitialState,
	action: AcCustomerAction,
): AcCustomerState => {
	switch (action.type) {
		case acCustomerTypes.FETCH_AC_CUSTOMERS_DATA:
			return {
				...state,
				customers: action.customers,
				customerCount: action.customerCount,
			};
        case acCustomerTypes.SET_AC_CUSTOMER_LIST_TABLE_PROPS:
              return {
                ...state,
                customerListTableProps: action.customerListTableProps
              }
        case acCustomerTypes.FETCH_AC_CUSTOMER_DETAIL_DATA:
              return {
                ...state,
                individualCustomerDetail: action.individualCustomerDetail,
              }
        case acCustomerTypes.FETCH_AC_CUSTOMER_CHARGERS_DATA:
              return {
                ...state,
                chargers: action.chargers,
                chargerCount: action.chargerCount
              }

        case acCustomerTypes.CLEAR_AC_CUSTOMER_LIST_DATA:
              return {
                ...state,
                // customers: null,
                // customerCount: 0,
                customerListTableProps: {
                  view: 'list',
                  sortBy: state.customerListTableProps?.sortBy || 'name',
                  order: state.customerListTableProps?.order || 'ascending',
                  pageSize: state.customerListTableProps?.pageSize || 15,
                  pageNumber: state.customerListTableProps?.pageNumber || 1,
                  searchTerm: ''
                },
              }
         case acCustomerTypes.CLEAR_AC_CUSTOMER_DETAIL_DATA:
              return {
                ...state,
                individualCustomerDetail: null,
              }
		default:
			return state;
	}
};

export default accustomersReducer;
